<template lang="html">
  <v-layout row wrap justify-center align-center style="height: 100vh;">
    <v-progress-circular :width="8" :size="80" color="primary" :indeterminate="progress"></v-progress-circular>
  </v-layout>
</template>

<script>
import { Decode } from '@/services'
export default {
  data () {
    return {
      progress: true,
      decoded: '',
      token: '',
      windowWidth: '',
      url_redirect: process.env.AuthenOneid
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  },
  created () {
    this.windowWidth = window.innerWidth
    console.log(`authen: ${process.env.AuthenOneid}`)
    localStorage.setItem('botid_redirect', this.$route.params.botid)
    this.$cookie.set('logouturl', this.$route.query.logouturl)
    console.log(`url: ${this.$route.query.logouturl}`)
    if (localStorage.getItem('Authenrization') !== null) {
      this.decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
      if (this.decoded.status_login !== 'T') {
        if (process.env.AuthenOneid) {
          window.open(this.url_redirect, '_parent')
        } else {
          this.$router.push('/login')
        }
      } else {
        // this.token = this.decoded['tokenuser']
        this.searchFriend(this.$route.params.botid, this.decoded['tokenuser'])
      }
    } else {
      // this.$router.push('/login')
      if (process.env.AuthenOneid) {
        window.open(this.url_redirect, '_parent')
      } else {
        console.log('to login')
        this.$router.push('/login')
      }
    }
  },
  methods: {
    searchFriend (botid, token) {
      this.axios.post(process.env.APIsearchfriend, {
        tokenbot: botid,
        tokenuser: token
      }).then((response) => {
        // console.log(response.data.listuser)
        if (response.data.listuser.length === 0) {
          this.progress = false
          localStorage.removeItem('botid_redirect')
          // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
          if (this.windowWidth <= 960) {
            this.$router.push('/mobile/homepage')
          } else {
            this.$router.push('/chat')
          }
        } else {
          if (response.data.listuser.relation === 'friend') {
            this.progress = false
            localStorage.removeItem('botid_redirect')
            if (this.windowWidth <= 960) {
              this.$router.push('/mobile/room/' + response.data.listuser.user.tokenroom)
            } else {
              this.$router.push('/chat/room/' + response.data.listuser.user.tokenroom)
            }
          } else {
            console.log('not friend')
            this.$router.push('/addbot/' + this.$route.params.botid)
          }
        }
      }).catch(error => {
        console.log(error)
        console.log(error.response)
        this.progress = false
        localStorage.removeItem('botid_redirect')
        // this.$swal('', 'ไม่มีข้อมูลบอทในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง', 'warning')
        if (this.windowWidth <= 960) {
          this.$router.push('/mobile/homepage')
        } else {
          this.$router.push('/chat')
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/homepage/RedirectChatRoom.vue